<template>
<div>
    <v-select
        label="Invoice Month"
        :items="items"
        :value="value"
        v-on:input="onChangeMonth"
    />
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: function() { return null; },
        },
    },

    mounted () {
        if ( this.value == null )
        {
            this.onChangeMonth(this.valueFromToday());
        }
    },

    methods: {

        onChangeMonth(val) {
            this.$emit('input',val);
        },

        valueFromDate(date)
        {
            let year = date.getFullYear();
            let month = date.getMonth() + 1;

            if ( month < 10 )
                return year+"-0"+month;
            
            return year + "-" + month;
        },

        valueFromToday()
        {
                let today = new Date();

                let last_month = new Date(today.getFullYear(), today.getMonth(), 0);
                
                return this.valueFromDate(last_month);
        },
    },

    computed: {
        items() {
            
            let ret = [];

            let first_day_of_month = new Date(2021,8,1);
            let today = new Date();

            while(first_day_of_month < today)
            {
                let last_day_of_month = new Date(first_day_of_month.getFullYear(), first_day_of_month.getMonth() + 1, 0);

                let month_name = first_day_of_month.toLocaleString('default', { month: 'long' });
                let year = ''+first_day_of_month.getFullYear();

                let text = month_name+' 1, '+year+' - '+month_name+' '+last_day_of_month.getDate()+', '+year;

                ret.push({
                    'text' : text,
                    'value' : this.valueFromDate(first_day_of_month),
                });
                
                first_day_of_month = new Date(first_day_of_month.getFullYear(), first_day_of_month.getMonth() + 1, 1);

            }

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>